import { typeof as _typeof, slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';

/**
 * Formats string, array entries, or object keys whose value evaluates to true
 * into a single className
 * For example ["  one  two ", undefined, null, { three: false, four: true }]
 * return  "one two four"
 */

var _formatClassName = function formatClassName(classNames) {
  if (classNames === undefined || classNames === null) {
    return;
  }
  var classes;
  if (Array.isArray(classNames)) {
    classes = classNames.map(function (className) {
      return _formatClassName(className);
    });
  } else if (_typeof(classNames) === 'object') {
    classes = Object.entries(classNames).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        cn = _ref2[0],
        val = _ref2[1];
      return val && cn;
    });
  } else if (typeof classNames === 'string') {
    classes = classNames.trim().split(' ');
  }
  if (classes) {
    classes = classes.filter(function (cn) {
      return cn;
    }).join(' ');
    if (!classes.length) {
      classes = undefined;
    }
  }
  return classes;
};
export { _formatClassName as formatClassName };